import { render, staticRenderFns } from "./DeliveryCustom.vue?vue&type=template&id=4c962f24&scoped=true"
import script from "./DeliveryCustom.vue?vue&type=script&lang=ts"
export * from "./DeliveryCustom.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryCustom.vue?vue&type=style&index=0&id=4c962f24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c962f24",
  null
  
)

export default component.exports